import React, { FC } from 'react';
import { Tabs as TabsAnt } from 'antd';
import { TabsProps, TabPaneProps } from 'antd/lib/tabs';
import { TabsStyled } from './styles';

const { TabPane } = TabsAnt;

export interface ITab extends TabsProps {
  tabs: ITabPane[];
}

export interface ITabPane extends TabPaneProps {
  title: string;
  children?: React.ReactNode;
}

const Tabs: FC<ITab> = (props) => {
  const { tabs, ...rest } = props as any;

  return (
    <>
      <TabsStyled />
      <TabsAnt {...rest}>
        {tabs?.map((pane: ITabPane, idx: number) => {
          const { title, children, tabKey, key, ...paneRest } = pane as any;
          const paneKey = tabKey ?? key ?? String(idx);

          return (
            <TabPane key={paneKey} {...paneRest} tab={title}>
              {children}
            </TabPane>
          );
        })}
      </TabsAnt>
    </>
  );
};

export default Tabs;
